import { render, staticRenderFns } from "./transfer_mold.vue?vue&type=template&id=1aec92fd&scoped=true&"
import script from "./transfer_mold.vue?vue&type=script&lang=js&"
export * from "./transfer_mold.vue?vue&type=script&lang=js&"
import style0 from "./transfer_mold.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./transfer_mold.vue?vue&type=style&index=1&id=1aec92fd&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aec92fd",
  null
  
)

export default component.exports